import * as React from 'react';

interface IconProperties {
  className?: string;
  width?: number;
  height?: number;
  viewBox?: string;
  title?: string;
  onClick?: () => void;
  opacity?: number;
  rotate?: string;
  fill?: string;
}

const ArrowDownThinIcon = ({
  width = 16,
  height = 16,
  fill = '#257C6B',
  className = '',
}: IconProperties) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="arrow-down-thin">
      <path
        id="Vector"
        d="M4.68652 9.2799H7.35319V3.33323L8.69319 3.31323V9.2799H11.3532L8.01986 12.6132L4.68652 9.2799Z"
        fill={fill}
      />
    </g>
  </svg>
);
export default ArrowDownThinIcon;
